var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatternLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 324,
    viewBox: "0 0 49 324",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-25.8086 56.8433L-25.911 73.6084L-8.74 0.928509L-12.5932 0.904968L-25.8086 56.8433ZM-21.8953 0.848137L-25.5613 16.365L-25.4664 0.82632L-21.8953 0.848137ZM0.56205 0.985339L-26.1583 114.087L-26.2608 130.852L4.41524 1.00888L0.56205 0.985339ZM13.7174 1.06571L-26.5081 171.33L-26.6105 188.095L17.5705 1.08925L13.7174 1.06571ZM26.8727 1.14608L-26.8578 228.573L-26.9602 245.339L30.7259 1.16962L26.8727 1.14608ZM40.028 1.22645L-27.2075 285.816L-27.31 302.582L43.8812 1.24999L40.028 1.22645ZM48.4086 21.5182L-22.7824 322.849L-18.9293 322.872L48.3061 38.2834L48.4086 21.5182ZM48.0589 78.7616L-9.62712 322.929L-5.77403 322.953L47.9564 95.5268L48.0589 78.7616ZM47.7091 136.005L3.52809 323.009L7.38128 323.033L47.6067 152.77L47.7091 136.005ZM47.3594 193.248L16.6834 323.09L20.5366 323.113L47.257 210.014L47.3594 193.248ZM47.0097 250.491L29.8387 323.17L33.6919 323.194L46.9072 267.257L47.0097 250.491ZM46.66 307.735L42.994 323.251L46.565 323.272L46.66 307.735Z",
    fill: "#FFC10F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternLeft);
export default __webpack_public_path__ + "static/media/Pattern-left.baa90bb65620c49ee5e6c761c8d3c7e3.svg";
export { ForwardRef as ReactComponent };